<template>
  <div>
    <v-row class="mb-4">
      <v-col>
        <h3 class="text-h6 font-weight-medium mb-4">
          Preferences
        </h3>
        <p class="text--secondary">
          Customize your application experience and display preferences.
        </p>
      </v-col>
    </v-row>

    <v-form @submit.prevent="handleSubmit">
      <!-- Theme Settings -->
      <v-row>
        <v-col>
          <v-subheader class="pl-0 text-h6">
            Theme & Appearance
          </v-subheader>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-select
            v-model="localPreferences.theme"
            :items="themeOptions"
            label="Theme"
            outlined
            @change="handleThemeChange"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-select
            v-model="localPreferences.language"
            :items="languageOptions"
            label="Language"
            outlined
          />
        </v-col>
      </v-row>

      <!-- Date & Time Settings -->
      <v-row>
        <v-col>
          <v-subheader class="pl-0 text-h6">
            Date & Time
          </v-subheader>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-select
            v-model="localPreferences.timezone"
            :items="timezoneOptions"
            label="Timezone"
            outlined
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-select
            v-model="localPreferences.dateFormat"
            :items="dateFormatOptions"
            label="Date Format"
            outlined
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-select
            v-model="localPreferences.timeFormat"
            :items="timeFormatOptions"
            label="Time Format"
            outlined
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex justify-end">
          <v-btn
            color="primary"
            :disabled="!hasChanges"
            :loading="loading"
            @click="handleSubmit"
          >
            Update Preferences
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'SettingsPreferences',
  props: {
    preferences: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localPreferences: {},
      themeOptions: [
        { text: 'Light', value: 'light' },
        { text: 'Dark', value: 'dark' },
      ],
      languageOptions: [
        { text: 'English', value: 'en' },
        { text: 'Spanish', value: 'es' },
        { text: 'French', value: 'fr' },
      ],
      timezoneOptions: [
        { text: 'UTC', value: 'UTC' },
        { text: 'Eastern Time', value: 'America/New_York' },
        { text: 'Central Time', value: 'America/Chicago' },
        { text: 'Mountain Time', value: 'America/Denver' },
        { text: 'Pacific Time', value: 'America/Los_Angeles' },
      ],
      dateFormatOptions: [
        { text: 'MM/DD/YYYY', value: 'MM/dd/yyyy' },
        { text: 'DD/MM/YYYY', value: 'dd/MM/yyyy' },
        { text: 'YYYY-MM-DD', value: 'yyyy-MM-dd' },
      ],
      timeFormatOptions: [
        { text: '12-hour (AM/PM)', value: '12h' },
        { text: '24-hour', value: '24h' },
      ],
    }
  },
  computed: {
    hasChanges() {
      return JSON.stringify(this.localPreferences) !== JSON.stringify(this.preferences)
    },
  },
  watch: {
    preferences: {
      handler(newPreferences) {
        this.localPreferences = { ...newPreferences }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleSubmit() {
      if (this.hasChanges) {
        this.$emit('update', this.localPreferences)
      }
    },
    handleThemeChange(theme) {
      // Emit theme change immediately for instant feedback
      this.$emit('update', { ...this.localPreferences, theme })
    },
  },
}
</script>
